<template>
  <div
    class="availability badge"
    :class="classes"
  >
    <template v-if="availability == 1">
      {{ $translate("Ecomsilio::Template.availability1") }}
    </template>
    <template v-else-if="availability == 5">
      {{ $translate("Ecomsilio::Template.availability5") }}
    </template>
  </div>
</template>

<script>
export default {
    name: "ItemListAvailability",
    props: { itemId: Number, itemFilter: Object, salableVariationCount: Number },
    data ()
    {
        return { availability: Number }
    },
    computed: {
        classes ()
        {
            return ["availability-" + (this.availability)]
        }
    },
    mounted ()
    {
        if (this.salableVariationCount > 0)
        {
            this.availability = 1
        }
        else
        {
            if (this.itemFilter.isSalable)
            {
                this.availability = 1
            }
            else
            {
                this.availability = 5
            }
        }
    }
}
</script>
